import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import ChecklistMasterContent from "../../components/Masters/ChecklistMaster/ChecklistMasterContent";
import { useDispatch, useSelector } from "react-redux";
import { getChecklistMastersList } from "../../redux/actions/mastersAction";

const ChecklistMaster = () => {
  const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(getChecklistMastersList());
  // }, []);
  return (
    <>
      <Sidebar activeTab="Masters" title="Masters">
        <Box className="globalContainer_For_Content">
          <ChecklistMasterContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default ChecklistMaster;
